import { useMutation } from '@tanstack/react-query';
import { Row } from 'antd';
import { Button } from 'components';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { MarketGoldPriceApis } from 'apis/goldPriceApis';
import { IGetAllGoldPrice } from 'apis/GraphQL/Variables/goldPrice';
import { Loader } from 'assets/svg';
import { useTitle } from 'contexts/TitleProvider';
import useQueryParam from 'hooks/useQueryPrams';
import { PageInfo } from 'interfaces/TeamSale/TeamSale';
import { DEFAULT_PAGE_SIZE } from 'utils/constants/constant';
import { convertDateToBE, toastError } from 'utils/constants/functions';
import { TableGoldPriceManagement } from './TableGoldPriceManagement';

const GoldPriceManagementPage = () => {
  const { setTitle, setBreadcrumb } = useTitle();
  const navigate = useNavigate();

  const [data, setData] = useState({
    pageInfo: {} as PageInfo,
    items: [] as any,
  });

  const queryParam = useQueryParam(),
    page = parseInt(queryParam.get('page') + '') || 1,
    pageSize = parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  useEffect(() => {
    setTitle('Quản lý giá vàng');
    setBreadcrumb([{ title: 'Hệ thống' }, { title: 'Quản lý giá vàng' }]);
  }, []);

  useEffect(() => {
    getMarketGoldPrice({ page, pageSize });
  }, [page, pageSize]);

  const { mutate: getMarketGoldPrice, isPending: isGetMarketGoldPricePending } =
    useMutation({
      mutationFn: (params: IGetAllGoldPrice) =>
        MarketGoldPriceApis.getAll({
          ...params,
          validFromDate: convertDateToBE(new Date()),
          // validToDate: convertDateToBE(new Date()),
        }),
      onSuccess: (res) => {
        setData(
          res?.data?.getMarketGoldPriceList ?? {
            pageInfo: {
              currentPage: 1,
              hasNextPage: false,
              hasPreviousPage: false,
              itemsPerPage: 10,
              totalItems: 0,
              totalPages: 0,
            },
            items: [],
          },
        );
      },
      onError: (error) => {
        toastError(error?.message);
      },
    });

  const refetchGoldPrice = useCallback(() => {
    navigate(`?page=1&page_size=${pageSize}`);

    if (page === 1) getMarketGoldPrice({ page: 1, pageSize });
  }, [pageSize]);

  return (
    <>
      <Row gutter={[8, 16]} align={'middle'} justify={'end'}>
        <Button
          fill
          title="Cập nhật"
          iconBefore={<Loader />}
          handleOnclick={refetchGoldPrice}
        />
      </Row>
      <TableGoldPriceManagement
        data={data}
        page={{ pageNum: page, pageSize: pageSize }}
        loading={isGetMarketGoldPricePending}
      />
    </>
  );
};

export default GoldPriceManagementPage;
